// extracted by mini-css-extract-plugin
export default {"token":"bVLjDG","hover":"cVLjDG","disabled":"dVLjDG"};